import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from './types/User';
import { APIV2_URL } from './constants';

export interface Payload {
  email: string;
  password: string;
}

const login = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<User>('POST', `${APIV2_URL}/action/login`, { data });

export default login;
